import { createModal } from "Components/Modal/helpers/createModal";
import { ScheduleEntry } from "domain-entities";

export const useScheduleEntryModal = createModal<ScheduleEntry>({});
